import React from 'react';

const useOutsideScroll = (callback) => {
  const ref = React.useRef();

  React.useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener('scroll', handleClick, true);

    return () => {
      document.removeEventListener('scroll', handleClick, true);
    };
  }, [ref]);

  return ref;
};

export default useOutsideScroll;
